import { createStore } from 'vuex'
//import {reaction} from 'mobx';
import { assignIn  ,  zipObject } from 'lodash';
import defaultForms from './defaultForms';
import jscookie from 'js-cookie'

export const wshost = location.hostname;
const store = createStore({
  state: {
    usr: {
      _id:null,
      informative:{},
      folders:{},
      devices:{},
      brand:{
        logo:'',
        color:'#1976d2'
      },
      forms:[]
    },
    connState: '',
    meta: {
      title: 'PrivacyReady Admin.',
      meta: {},
    },
    uu:[],
    wshost,
    publicPath: `https://${wshost}/public/`,
    path:[],
    staticLink: {
      text:'',
      url:'',
      icon:''
    },
    settings:{
      _id:'gdpr'
    }
  },
  mutations: {
    SET_CONNECTION_STATE: (state, v) => {
      state.connState = v
    },
    SET_META: (state, obj) => {
      assignIn(state.meta, obj)
    },
    SOCKET_SET_USR: (state, obj) => {
      Object.assign(state.usr, obj);
    },
    setStaticLink:(state,obj)=>{
      Object.assign(state.staticLink,obj);
    },
    logout:({settings})=>{
      localStorage.clear();
      sessionStorage.clear()
      jscookie.remove('t-'+settings._id);
      setTimeout(()=>window.location.reload(),100)
    },
    assignInformative:(state,data)=>{
      Object.assign(state.usr.informative,data)
    }
  },
  actions: {
    getInformativaUrl(id,formId){
      `https://${this.$store.state.wshost}/informativa/${id}/${formId}/PrivacyReady.html`
    },
  },
  modules: {},
  getters:{
    canEdit({usr}){
      return !usr.org || usr.org.role !=='operator'
    },
    isAdmin({usr}){
      return !usr.org?._id || usr.org._id == usr._id || usr.org?.role == 'admin'
    },
    path(){
      return window.app.config.globalProperties.$route.fullPath
    },
    isConnected(state){
      return state.connState.startsWith('connect')
    },
    groupedInformative(state){
      let informative = state.usr.informative || {};
      /* if (!this.archived) {
        informative = pickBy(informative, i=>!i.archived)
      } */
      let allGroups = Array.from(new Set(Object.keys(informative).map(k=> state.usr.informative[k].categories).flat()));
      allGroups.push(undefined);
      allGroups = zipObject(allGroups, allGroups.map(g=>Object.values( state.usr.informative).filter(c=>g ? c.categories?.includes(g) : (!c.categories?.length) )));
      return allGroups;
    },
    categorieInformative(state,{groupedInformative}){
      return Object.keys(groupedInformative).filter(x=>x && String(x).length);
    },
    usrForms({usr}){
      return Object.keys({ ...defaultForms, ...usr.forms }).map(_id=>({...(usr.forms[_id]|| defaultForms[_id]),_id })) 
    }
  }
})

export default store
